import React from 'react';
import { makeStyles } from '@mui/styles';
import FormControl from '@mui/material/FormControl';
import { TextField } from '@mui/material';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  formControl: {
    margin: 15,
    minWidth: 120,
    width: '40%'
  },
  inputLabel: {
    fontSize: '14px'
  }
}));

const theme = createTheme({
  overrides: {
    MuiInputLabel: {
      root: {
        fontSize: '14px'
      }
    }
  },
});

export default function FiscalYearFilter({minFiscalYear, maxFiscalYear, setMinFiscalYear, setMaxFiscalYear}) {
  const classes = useStyles();
  const dispatch = useDispatch();
  //const[min, setMin] = useState(minFiscalYear);
  //const[max, setMax] = useState(maxFiscalYear);

  const handleChangeMin = (event) => {
    let val = event.target.value;
    if(event.target.value === null){
      val = "";
    }
    //setMin(val);
    dispatch(setMinFiscalYear(val))
  };

  const handleChangeMax = (event) => {
    let val = event.target.value;
    if(event.target.value === null){
      val = "";
    }
    //setMax(val);
    dispatch(setMaxFiscalYear(val))
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        <FormControl className={classes.formControl}>
          <TextField
            id="fiscalYearMin"
            label="Min Fiscal Year"
            type="number"
            variant="standard"
            className='inputLabel'
            onChange={handleChangeMin}
            value={minFiscalYear === null ? "" : minFiscalYear}
            name="min"
          />
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            id="fiscalYearMax"
            label="Max Fiscal Year"
            type="number"
            variant="standard"
            className='inputLabel'
            onChange={handleChangeMax}
            value={maxFiscalYear === null ? "" : maxFiscalYear}
            name="max"
          />
        </FormControl>
      </ThemeProvider>
    </div>
  );
}

FiscalYearFilter.propTypes = {
  minFiscalYear: PropTypes.any,
  maxFiscalYear: PropTypes.any, 
  setMinFiscalYear: PropTypes.any, 
  setMaxFiscalYear: PropTypes.any
}

